<template>
  <ul class="LmTreeSelector">
    <node-selector
      v-for="actor in currentLandscape.actors"
      :key="actor._id"
      v-model="actors"
      :actor="actor"
    />
  </ul>
</template>

<script>
import {mapGetters} from 'vuex'
import NodeSelector from './treeSelector/NodeSelector'

export default {
  name: 'LmTreeSelector',
  components: {NodeSelector},
  model: {
    prop: 'actors'
  },
  props: {
    actors: {
      // v-model
      type: Array,
      required: true
    }
  },
  computed: mapGetters(['currentLandscape'])
}
</script>

<style scoped>
.LmTreeSelector {
  margin: 0;
  padding: 0;
  .NodeSelector {
    position: relative;
    padding: 20px 0 0;
  }
}
</style>
